import script from "./OpenPosition.vue?vue&type=script&setup=true&lang=js"
export * from "./OpenPosition.vue?vue&type=script&setup=true&lang=js"

import "./OpenPosition.vue?vue&type=style&index=0&id=2d2a685e&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2d2a685e"]])

export default __exports__